import React,{useEffect} from 'react';
import { Container,Paper,Typography,Box,Button} from '@material-ui/core';
import {useSelector,useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';

import {useStyles} from './styles';
import {getSingleMatch} from '../../actions/match';


const Matches = () => {
   
    const classes=useStyles();
    const dispatch=useDispatch();
    const history=useHistory();

    const matches=useSelector((state)=>state.matches);

    const selectHandle=(match)=>{
        console.log("match selected from matchjs",match)
        dispatch(getSingleMatch(match))
        history.push("/players");
    }

    if(matches?.length===0){
        return (
            <h1>Loading....</h1>
        )
    }
    return (
        <Container className={classes.container}>
           {
               matches?.map((match)=>{
                   return  <Paper elevation={3} className={classes.paper}>
                   <Box component="div" display="flex" justifyContent="flex-end"><Typography variant="body2" style={{marginBottom:'10px'}}> on {new Date(match["info"].dates[0]).toLocaleDateString()}</Typography></Box>
                       <Typography align="center">{match["info"].teams[0]}</Typography>
                       <Typography align="center" varaint="caption" style={{color:'#4CA1A3'}}>vs</Typography>
                       <Typography align="center">{match["info"].teams[1]}</Typography>
                      <Box component="div" display="flex" justifyContent="center" alignItems="center" style={{marginTop:'10px'}}>
                      <Button variant="contained" className={classes.playButton} onClick={()=>selectHandle(match)} >play</Button>
                      </Box>
                   </Paper>
               })
           }
        </Container>
     )
}

export default Matches
